module.exports = __webpack_public_path__ + "media/honey-icons/icon-television-3be77f4a.svg";